<template>
    <views class="verify-approval">
        <nav-bar
            :title="moduleTitle"
            @click-left="onClickLeft">
        </nav-bar>
        <views class="verify-approval-img">
            <images :src="imgUrl"></images>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    name: 'Verify',
    mixins: [tools],
    components: {
        NavBar
    },
    data() {
        return {
            imgUrl: require('@/assets/test/hgz.png')
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        moduleTitle() {
            return '查看合格证'
        }
    },
    created() {
        this.getProductCertificate()
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        getProductCertificate() {
            //  TODO 固定产品合格证 eslint-err 16行记得引入
            api.getProductCertificate({ id: this.query.codeId }).then((res) => {
                if (res.data && res.data.url) {
                    this.imgUrl = res.data.url
                }
            }).catch(e => {
                this.alert('提示', e).then(() => {
                    this.back()
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
